import React, { useState, useEffect } from 'react';
import styles from "./sucursales.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Select from 'react-select'

export default function ModalSucursales(props) {
    const { show, setShow, roles, dataEdit, setDataEdit,state,municipal,handleUpdate } = props;
    const [name, setName] = useState("");
    const [identifier, setIdentifier] = useState("");
    const [stateSelect, setStateSelect] = useState(null);
    const [municipalFilter, setMunicipalFilter] = useState([]);
    const [municipalSelect, setMunicipalSelect] = useState(null);
    const [update, setUpdate] = useState(false);

    const handleAgregar = () => {
        if (name === "" || identifier === "" || municipalSelect === null || stateSelect === null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {
                let payload = {
                    id:dataEdit.id,
                    identifier: identifier,
                    description: name,
                    stateId: stateSelect.value,
                    municipalityId: municipalSelect.value
                }
                api(SERVICE.updateOfices, payload, "PUT")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else {
                let payload = {
                    identifier: identifier,
                    description: name,
                    stateId: stateSelect.value,
                    municipalityId: municipalSelect.value
                }
                api(SERVICE.setOfices, payload, "POST")
                    .then((data) => {
                        let response = data.data;
                        if (response.status) {
                            handleUpdate();
                            setShow(false);
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Guardado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        }
                        else {
                            Swal.fire({
                                title: response.generalMessage,
                                icon: 'error',
                                confirmButtonText: 'Aceptar'
                            })
                        }

                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }

        }

    }
    useEffect(() => {
        if (!show && roles.length > 0) {
            // setEmail("");
            // setKey1("");
            // setKey2("");
            // setName("");
            // setLastName("");
            // setUserName("");
            // setRol(roles[0].id);
            // setDataEdit(null);
        }
    }, [show, roles])
    useEffect(() => {
        if (dataEdit != null) {
            console.log(dataEdit);
            setUpdate(true);
            setName(dataEdit.description);
            setIdentifier(dataEdit.identifier);
            setStateSelect({
                value: dataEdit.stateId,
                label: dataEdit.stateName
            });
            setMunicipalSelect({
                value: dataEdit.municipalityId,
                label: dataEdit.municipalityName,
                stateId: dataEdit.stateId
            });
            setTimeout(()=>{
                setUpdate(false);
            },1000);
        }
    }, [dataEdit])
    useEffect(() => {
        if (stateSelect != null && municipal &&  municipal.length>0) {
            if(!update){
                setMunicipalSelect(null);
            }
            let ArrayTemp = [];
            for (let index = 0; index < municipal.length; index++) {
                const element = municipal[index];
                if(element.stateId === stateSelect.value){
                    ArrayTemp.push(element);
                }
                
            }
            setMunicipalFilter(ArrayTemp);
        }
    }, [stateSelect,municipal])
    useEffect(() => {
            if (!show) {
                setName("");
                setIdentifier("");
                setStateSelect(null);
                setMunicipalSelect(null);
                setDataEdit(null);
            }
        }, [show])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit!=null?"Editar Sucursal":"Nueva Sucursal"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm}>
                        <div className={styles.itemForm} style={{ width: "60%" }}>
                            <label className="form-label">Nombre de la sucursal</label>
                            <input type="text" className="form-control" placeholder="Nombre de la sucursal" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "40%" }}>
                            <label className="form-label">Identificador</label>
                            <input type="text" className="form-control" placeholder="Identificador único" value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label className="form-label">Estado</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={state} 
                                    value={stateSelect} 
                                    onChange={(e) => setStateSelect(e)}
                                    placeholder="Seleccionar estado..."
                                />
                            </div>
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label className="form-label">Municipio</label>
                            <div className={styles.selectContainer}>
                                <Select 
                                    options={municipalFilter} 
                                    value={municipalSelect} 
                                    onChange={(e) => setMunicipalSelect(e)}
                                    placeholder="Seleccionar municipio..."
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit!=null?"Editar":"Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}